import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';

export const Good = ({ color }) => (
  <SentimentSatisfiedAltIcon fontSize="large" sx={{ color }} />
);
